var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleStandard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 1.5H59.3585H67V12.1842V42.7105L38.9811 59.5L13 41.693V12.1842V1.5Z",
    stroke: "#999999",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5768 23.2812L34.2526 28.2422L36.9284 23.2812H40.278L36.1471 30.332L40.3854 37.5H37.0065L34.2526 32.4414L31.4987 37.5H28.1002L32.3483 30.332L28.2077 23.2812H31.5768ZM51.3236 35.3027V37.5H41.597V35.625L46.1966 30.6934C46.6589 30.179 47.0235 29.7266 47.2904 29.3359C47.5573 28.9388 47.7494 28.584 47.8666 28.2715C47.9903 27.9525 48.0521 27.6497 48.0521 27.3633C48.0521 26.9336 47.9805 26.5658 47.8373 26.2598C47.694 25.9473 47.4824 25.7064 47.2025 25.5371C46.9291 25.3678 46.5905 25.2832 46.1869 25.2832C45.7572 25.2832 45.3861 25.3874 45.0736 25.5957C44.7676 25.804 44.5332 26.0938 44.3705 26.4648C44.2142 26.8359 44.1361 27.2559 44.1361 27.7246H41.3138C41.3138 26.8783 41.5157 26.1035 41.9193 25.4004C42.3229 24.6908 42.8926 24.1276 43.6283 23.7109C44.364 23.2878 45.2364 23.0762 46.2455 23.0762C47.2416 23.0762 48.0814 23.2389 48.765 23.5645C49.4551 23.8835 49.9759 24.3457 50.3275 24.9512C50.6856 25.5501 50.8646 26.2663 50.8646 27.0996C50.8646 27.5684 50.7897 28.0273 50.64 28.4766C50.4903 28.9193 50.2754 29.362 49.9955 29.8047C49.722 30.2409 49.39 30.6836 48.9994 31.1328C48.6087 31.582 48.1758 32.0475 47.7005 32.5293L45.2298 35.3027H51.3236Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 59,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleStandard);
export default __webpack_public_path__ + "static/media/double_standard.9e75e517b1fd14e87c0046e42e512255.svg";
export { ForwardRef as ReactComponent };